import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { Button } from './ui/button';
import { X, Sun } from 'lucide-react';

const WelcomeModal = () => {
  const { user } = useAuth();
  const [show, setShow] = useState(false);
  const [closing, setClosing] = useState(false);

  useEffect(() => {
    // Check if user just logged in (show once per session)
    // Don't show during onboarding tour
    const hasSeenWelcome = sessionStorage.getItem('welcomeShown');
    if (user && !hasSeenWelcome && user.onboarding_completed !== false) {
      // Small delay for better UX
      const timer = setTimeout(() => {
        setShow(true);
        sessionStorage.setItem('welcomeShown', 'true');
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [user]);

  const handleClose = () => {
    setClosing(true);
    setTimeout(() => {
      setShow(false);
      setClosing(false);
    }, 300);
  };

  if (!show || !user) return null;

  // Get first name
  const firstName = user.full_name?.split(' ')[0] || 'Użytkownik';

  return (
    <div className={`fixed inset-0 z-[100] flex items-center justify-center p-4 transition-opacity duration-300 ${closing ? 'opacity-0' : 'opacity-100'}`}>
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-navy-900/60 backdrop-blur-sm"
        onClick={handleClose}
      />
      
      {/* Modal */}
      <div className={`relative bg-white rounded-2xl shadow-2xl max-w-md w-full p-8 transform transition-all duration-300 ${closing ? 'scale-95 opacity-0' : 'scale-100 opacity-100'}`}>
        {/* Close button */}
        <button
          onClick={handleClose}
          className="absolute top-4 right-4 p-1 rounded-full hover:bg-slate-100 transition-colors"
          data-testid="welcome-close-btn"
        >
          <X className="w-5 h-5 text-slate-400" />
        </button>

        {/* Content */}
        <div className="text-center">
          {/* Icon */}
          <div className="mx-auto w-20 h-20 bg-gradient-to-br from-gold-400 to-gold-600 rounded-full flex items-center justify-center mb-6 shadow-lg shadow-gold-400/30">
            <Sun className="w-10 h-10 text-white" />
          </div>

          {/* Greeting */}
          <h2 className="text-2xl font-bold text-navy-800 mb-2" data-testid="welcome-greeting">
            Dzień dobry, {firstName}!
          </h2>
          
          <p className="text-slate-600 mb-2">
            Miło Cię widzieć dzisiaj w pracy.
          </p>
          
          <p className="text-slate-500 text-sm mb-6">
            Życzymy spokojnego i efektywnego dnia.
          </p>

          {/* Action button */}
          <Button
            onClick={handleClose}
            className="w-full bg-gold-500 hover:bg-gold-600 text-navy-800 font-semibold h-11"
            data-testid="welcome-start-btn"
          >
            Zaczynamy!
          </Button>
        </div>

        {/* Decorative elements */}
        <div className="absolute -top-2 -left-2 w-8 h-8 bg-gold-400/20 rounded-full" />
        <div className="absolute -bottom-3 -right-3 w-12 h-12 bg-navy-600/10 rounded-full" />
      </div>
    </div>
  );
};

export default WelcomeModal;
